export default __webpack_public_path__ + "static/media/@blogdoceapego.4a83d767.jpg";